import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import ProcessDetails from "./process_details.jsx";
import ActivityForm from './activity_form.jsx';
import ActivityFormResultMessages from "./activity_form_result_messages.jsx";
import { ProcessStore, ProcessActions } from '../reflux/process_store';

import ActivityStatuses from "../constants/activity_statuses";
import ProcessActionRoutes from "../constants/process_action_routes";
import { FormActions } from '../../form/reflux/form_store';

import Divider from '../../realize_overrides/components/divider/divider.jsx';

import { ActivityFormEventHandler, ActivityFormEvents } from '../../process/events/activity_form_event_handler';

import { getParamUrl } from '../../utils/query_string_parser';
import { HOST_NAME_API } from '../../../../../shared/serverInfo.js';

const newWS = getParamUrl("newWS") === "true";

@mixin.decorate(Reflux.listenTo(ProcessStore, "onProcessStoreLoad"))
export default class ActivityFormContainer extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			init: false,
			displayFormResult: this.props.displayFormResult,
			displayFormHeader: this.props.displayFormHeader,
			loadedWithErrors: false,
			id: `proccess-${this.props.processIds.processInstanceId}-${this.props.processIds.activityInstanceId}-${this.props.processIds.cycle}`,
			waitingForAction: this.props.waitingForAction,
			highContrast: this.props.highContrast
		};
	}

	static propTypes = {
		formStoreId: PropTypes.string,
		isMobile: PropTypes.bool,
		processIds: PropTypes.object,
		processInstanceData: PropTypes.object,
		displayFormResult: PropTypes.bool,
		displayFormHeader: PropTypes.bool,
		waitingForAction: PropTypes.bool,
		formResultMessages: PropTypes.array,
		isCurrentProcess: PropTypes.bool,
		isPublic: PropTypes.bool,
		language: PropTypes.string,
		gatewayUrl: PropTypes.string,
		lecomBpmUrl: PropTypes.string,
		actionEmail: PropTypes.oneOf(['P', 'R']),
		dataPrintEnabled: PropTypes.bool,
		isECMLicenseFull: PropTypes.bool,
		highContrast: PropTypes.bool,
		timeZone: PropTypes.string
	};

	static defaultProps = {
		isMobile: false,
		processIds: {},
		processInstanceData: {},
		displayFormResult: false,
		displayFormHeader: true,
		waitingForAction: true,
		formResultMessages: [],
		isCurrentProcess: true,
		isPublic: false,
		language: 'pt_BR',
		gatewayUrl: '',
		lecomBpmUrl: '',
		actionEmail: '',
		dataPrintEnabled: false,
		highContrast: false,
		timeZone: "America/Sao_Paulo",
		isECMLicenseFull: false
	};

	onProcessStoreLoad(store, callback) {
		if (store.id === this.state.id) {
			if (callback) {
				this.setState(store, () => {
					callback.apply(arguments);
				});
			} else {
				this.setState(store);
			}
		}
	}

	componentDidMount() {
		if (this.props.ticket) {
			localStorage.setItem("ticket", this.props.ticket);
		}

		if (this.props.language) {
			localStorage.setItem("language", this.props.language);
		}

		if (this.props.uuid) {
			localStorage.setItem("uuid", this.props.uuid);
		}						

		FormActions.init({
			formId: null,
			id: `form-${this.props.processIds.processInstanceId}-${this.props.processIds.activityInstanceId}-${this.props.processIds.cycle}`,
			definitionURL: ProcessActionRoutes.SHOW_ACTIVITY_FORM,
			definitionParams: {
				processInstanceId: this.props.processIds.processInstanceId,
				activityInstanceId: this.props.processIds.activityInstanceId,
				cycle: this.props.processIds.cycle,
				isMobile: this.props.isMobile
			},
			formLoaded: false,
			loadOnInit: false,
			waitingForAction: this.props.waitingForAction,			
			readOnly: false,
			isMobile: this.props.isMobile,
			isECMLicenseFull: this.props.isECMLicenseFull,
			dataPrintEnabled: this.props.dataPrintEnabled,
			highContrast: this.props.highContrast,
			initialValuesDataStoreRoute: {
				id: null,
				name: "FormInitialValues",
				noContextPath: true,
				url: `${HOST_NAME_API}/form/form-initial-values`,
				httpMethod: "GET",
				resourceName: "_embedded.fieldInitialValues",
				params: [
					{
						name: "processInstanceId",
						value: this.props.processIds.processInstanceId
					},
					{
						name: "activityInstanceId",
						value: this.props.processIds.activityInstanceId
					},
					{
						name: "cycle",
						value: this.props.processIds.cycle
					}
				]
			}
		});		

		ProcessActions.init({
			id: this.state.id,
			isMobile: this.props.isMobile,
			processIds: this.props.processIds,
			processInstanceData: {},
			displayFormResult: this.state.displayFormResult,
			displayFormHeader: this.state.displayFormHeader,
			waitingForAction: this.props.waitingForAction,
			formResultMessages: this.props.formResultMessages,
			isCurrentProcess: this.props.isCurrentProcess,
			uuid: this.props.uuid,
			ticket: this.props.ticket,
			isPublic: this.props.isPublic,
			language: this.props.language,
			gatewayUrl: this.props.gatewayUrl,
			lecomBpmUrl: this.props.lecomBpmUrl,
			isTestMode: this.props.isTestMode,
			actionEmail: this.props.actionEmail,
			dataPrintEnabled: this.props.dataPrintEnabled,
			isECMLicenseFull: this.props.isECMLicenseFull,
			highContrast: this.props.highContrast,
			timeZone: this.props.timeZone,
			definitionURL: ProcessActionRoutes.SHOW_ACTIVITY_FORM,
			definitionParams: {
				processInstanceId: this.props.processIds.processInstanceId,
				activityInstanceId: this.props.processIds.activityInstanceId,
				cycle: this.props.processIds.cycle,
				isMobile: this.props.isMobile
			}
		});
	}

	getStatus() {
		return this.state && this.state.processInstanceData ? this.state.processInstanceData.status : "";
	}

	isActivityInProgress() {
		return  this.getStatus() === "" ? false : this.getStatus() == ActivityStatuses.IN_PROGRESS;
	}

	renderProcessDetails() {
		if (!this.state || !this.state.processInstanceData || !this.state.displayFormHeader)
			return <span />;

		const processInstanceData = this.state.processInstanceData;

		return (
			<ProcessDetails
				processIds={processInstanceData.processIds}
				title={processInstanceData.title}
				userName={processInstanceData.userName}
				status={processInstanceData.status}
				processInstanceId={processInstanceData.processInstanceId}
				isMobile={this.props.isMobile}
				isECMLicenseFull={this.props.isECMLicenseFull} 
			/>
		);
	}

	renderDivider() {
		if(!this.props.isMobile)
			return <span />;

		return <Divider />;
	}

	renderFormOrResult() {

		if (this.state.displayFormResult) {
			ActivityFormEventHandler.publish(ActivityFormEvents.FORM_PROCESS_FINISH);
			return (
				<ActivityFormResultMessages
					processInstanceData={this.state.processInstanceData}
					formResultMessages={this.state.formResultMessages}
					isMobile={this.props.isMobile} />
			);
		} else {
			return (
				<ActivityForm
					processIds={this.props.processIds}
					processInstanceData={this.state.processInstanceData}
					displayFormHeader={this.state.displayFormHeader}
					waitingForAction={this.state.waitingForAction}
					isMobile={this.props.isMobile}
					formStoreId={`form-${this.props.processIds.processInstanceId}-${this.props.processIds.activityInstanceId}-${this.props.processIds.cycle}`}
					readOnly={!this.isActivityInProgress()}
					uniqueStoreItemId={this.state.id}
					dataPrintEnabled={this.props.dataPrintEnabled} />
			);
		}
	}

	render() {
		if (this.state && this.state.processInstanceData || this.state.loadedWithErrors) {
			return (
				<div className="activity-form__container" data-testid="activity-form-container">
					{newWS !== true &&
						this.renderProcessDetails()
					}

					{newWS !== true &&
						this.renderDivider()
					}

					{this.renderFormOrResult()}
				</div>
			);
		}
		
		return <span />
	}
}